import { ExecutionResult } from 'react-apollo';
import { DataProxy } from 'apollo-cache';
import { DocumentNode } from 'graphql';
import { remove } from 'lodash';

import {
  GetManualNotificationsDocument,
  ManualNotificationsItem,
  QueryGetManualNotificationItemsArgs,
} from 'api';

interface IReducer {
  cache: DataProxy;
  result: ExecutionResult['data'];
  query: DocumentNode;
  variables: QueryGetManualNotificationItemsArgs;
}

export default (options: IReducer) => {
  const { cache, result, query } = options;
  const scheduledQuery: ExecutionResult['data'] = cache.readQuery({
    query,
    variables: { scheduled: true },
  });

  const sentQuery: ExecutionResult['data'] = cache.readQuery({
    query,
    variables: { scheduled: false },
  });

  const scheduledItems = scheduledQuery.getManualNotificationItems;
  const sentItems = sentQuery.getManualNotificationItems;

  if (!scheduledItems || !sentItems) {
    return;
  }

  const { updateManualNotification } = result.data;

  scheduledItems.count--;
  remove(scheduledItems.items, (item: ManualNotificationsItem) => {
    return item.id === updateManualNotification.id;
  });

  sentItems.count++;
  sentItems.items.splice(0, 0, updateManualNotification);

  cache.writeQuery({
    query: GetManualNotificationsDocument,
    variables: { scheduled: true },
    data: {
      getManualNotificationItems: scheduledItems,
    },
  });

  cache.writeQuery({
    query: GetManualNotificationsDocument,
    variables: { scheduled: false },
    data: {
      getManualNotificationItems: sentItems,
    },
  });
};
